import axios from "axios"
var baseUrl

if(process.env.NODE_ENV === 'development') {
   baseUrl = "https://financeiro.backendtropa.com.br/"
    //baseUrl = "https://amazoncopy.backendtropa.com.br/"
    // baseUrl = 'https://54f6-191-13-211-74.ngrok-free.app/';

} else {
    baseUrl = "https://financeiro.backendtropa.com.br/"
}

const api = axios.create({
    baseURL: baseUrl,

    headers: {
        'Authorization': 'Bearer ' + (localStorage.getItem('token') || '')
    }
})

export default api
